import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.replace.js";
import React from 'react';
import Search from './search';
import classNames from 'classnames';
import Animate from '../../wui-animate/src';
import PureRenderMixin from './PureRenderMixin';
import assign from 'object-assign';
import Item from './item';
import Checkbox from '../../wui-checkbox/src';
import Icon from '../../wui-icon/src';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { KeyCode } from '../../wui-core/src';

function noop() {}

var defaultProps = {
  dataSource: [],
  titleText: '',
  showSearch: false,
  render: noop
};

function isRenderResultPlainObject(result) {
  return result && ! /*#__PURE__*/React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
}

var TransferList = /*#__PURE__*/function (_React$Component) {
  _inherits(TransferList, _React$Component);

  var _super = _createSuper(TransferList);

  function TransferList(props) {
    var _this;

    _classCallCheck(this, TransferList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "matchFilter", function (text, item) {
      //filter：搜索框中的内容
      //filterOption：用户自定义的搜索过滤方法
      var _this$props = _this.props,
          filter = _this$props.filter,
          filterOption = _this$props.filterOption;

      if (filterOption) {
        return filterOption(filter, item);
      }

      return text.indexOf(filter) >= 0;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (selectedItem) {
      // checkedKeys：已勾选的Keys数组
      // result：是否已勾选，true：已勾选  false：未勾选
      var checkedKeys = _this.props.checkedKeys;
      var result = checkedKeys.some(function (key) {
        return key === selectedItem.key;
      });

      _this.props.handleSelect(selectedItem, result);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilter", function (e) {
      _this.props.handleFilter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      _this.props.handleClear();
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (item) {
      var _this$props$render = _this.props.render,
          render = _this$props$render === void 0 ? noop : _this$props$render;
      var renderResult = render(item);
      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
      return {
        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
        renderedEl: isRenderResultPlain ? renderResult.label : renderResult
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event, provided, snapshot, item) {
      if (provided.dragHandleProps) {
        provided.dragHandleProps.onKeyDown(event);
      }

      if (event.defaultPrevented) {
        return;
      }

      if (snapshot.isDragging) {
        return;
      }

      if (event.keyCode !== KeyCode.ENTER) {
        return;
      } // 为了选择，我们使用此事件 we are using the event for selection


      event.preventDefault();

      _this.performAction(event, item);
    });

    _this.state = {
      mounted: false
    };
    return _this;
  }

  _createClass(TransferList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.timer = setTimeout(function () {
        _this2.setState({
          mounted: true
        });
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return PureRenderMixin.shouldComponentUpdate.apply(this, args);
    }
  }, {
    key: "getCheckStatus",
    value:
    /**
     * 获取Checkbox状态
     * @param {*} filteredDataSource dataSource中刨去设置为disabled的部分
     */
    function getCheckStatus(filteredDataSource) {
      var checkedKeys = this.props.checkedKeys;

      if (checkedKeys.length === 0) {
        return 'none'; //全部未选
      } else if (filteredDataSource.every(function (item) {
        return checkedKeys.indexOf(item.key) >= 0;
      })) {
        return 'all'; //全部已选
      }

      return 'part'; //部分已选
    }
    /**
     * 点击list item，选中或取消选中
     * @param selectedItem 选中的item的信息，和dataSource数据源中的item信息一致
     */

  }, {
    key: "renderCheckbox",
    value: function renderCheckbox(_ref) {
      var _classNames,
          _this3 = this;

      var prefixCls = _ref.prefixCls,
          filteredDataSource = _ref.filteredDataSource,
          checked = _ref.checked,
          checkPart = _ref.checkPart,
          disabled = _ref.disabled,
          checkable = _ref.checkable;
      var checkAll = !checkPart && checked; //非半选 && 全选

      prefixCls = "u";
      var checkboxCls = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkbox-indeterminate"), checkPart), _defineProperty(_classNames, "".concat(prefixCls, "-checkbox-disabled"), disabled), _classNames));
      return /*#__PURE__*/React.createElement("span", {
        className: "u-checkbox-wrapper"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          return _this3.props.handleSelectAll(filteredDataSource, checkAll);
        },
        className: checkboxCls,
        checked: checkAll
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2,
          _this4 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          dataSource = _this$props2.dataSource,
          titleText = _this$props2.titleText,
          filter = _this$props2.filter,
          checkedKeys = _this$props2.checkedKeys,
          lazy = _this$props2.lazy,
          filterOption = _this$props2.filterOption,
          _this$props2$body = _this$props2.body,
          body = _this$props2$body === void 0 ? noop : _this$props2$body,
          _this$props2$footer = _this$props2.footer,
          footer = _this$props2$footer === void 0 ? noop : _this$props2$footer,
          showSearch = _this$props2.showSearch,
          _this$props2$render = _this$props2.render,
          render = _this$props2$render === void 0 ? noop : _this$props2$render,
          style = _this$props2.style,
          id = _this$props2.id,
          showCheckbox = _this$props2.showCheckbox,
          draggable = _this$props2.draggable,
          droppableId = _this$props2.droppableId,
          draggingItemId = _this$props2.draggingItemId;
      var _this$props3 = this.props,
          searchPlaceholder = _this$props3.searchPlaceholder,
          notFoundContent = _this$props3.notFoundContent; // Custom Layout

      var footerDom = footer(assign({}, this.props));
      var bodyDom = body(assign({}, this.props));
      var listCls = classNames(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-with-footer"), !!footerDom), _defineProperty(_classNames2, "".concat(prefixCls, "-draggable"), !!draggable), _classNames2));
      var filteredDataSource = [];
      var totalDataSource = [];
      var showItems = dataSource.map(function (item, index) {
        if (!item) {
          return;
        }

        var _this4$renderItem = _this4.renderItem(item),
            renderedText = _this4$renderItem.renderedText,
            renderedEl = _this4$renderItem.renderedEl;

        if (filter && filter.trim() && !_this4.matchFilter(renderedText, item)) {
          return null;
        } // all show items


        totalDataSource.push(item);

        if (!item.disabled) {
          filteredDataSource.push(item);
        }

        var checked = checkedKeys.indexOf(item.key) >= 0;
        return /*#__PURE__*/React.createElement(Draggable, {
          key: item.key,
          index: index,
          draggableId: "".concat(item.key),
          isDragDisabled: draggable ? item.disabled : !draggable
        }, function (provided, snapshot) {
          return /*#__PURE__*/React.createElement("div", _extends({
            ref: provided.innerRef
          }, provided.draggableProps, provided.dragHandleProps, {
            // onClick={(event) =>this.handleDrag(event, provided, snapshot, item)}
            onKeyDown: function onKeyDown(event) {
              return _this4.onKeyDown(event, provided, snapshot, item);
            } // className={classnames({
            //     ...getClass(this.props,snapshot.isDragging).drag
            //   })}
            ,
            style: _objectSpread({}, provided.draggableProps.style)
          }), /*#__PURE__*/React.createElement(Item // ref={provided.innerRef} //Error: provided.innerRef has not been provided with a HTMLElement
          // key={item.key}
          , {
            item: item,
            lazy: lazy,
            render: render,
            renderedText: renderedText,
            renderedEl: renderedEl,
            filter: filter,
            filterOption: filterOption,
            checked: checked,
            checkedKeys: checkedKeys,
            prefixCls: prefixCls,
            onClick: _this4.handleSelect,
            showCheckbox: showCheckbox,
            isMultiDragSource: draggingItemId === item.key,
            draggingItemId: draggingItemId
          }));
        });
      });
      var unit = '';
      var antLocale = this.context.antLocale;

      if (antLocale && antLocale.Transfer) {
        var transferLocale = antLocale.Transfer;
        unit = dataSource.length > 1 ? transferLocale.itemsUnit : transferLocale.itemUnit;
        searchPlaceholder = searchPlaceholder || transferLocale.searchPlaceholder;
        notFoundContent = notFoundContent || transferLocale.notFoundContent;
      }

      var checkStatus = this.getCheckStatus(filteredDataSource);
      var outerPrefixCls = prefixCls.replace('-list', '');
      var search = showSearch ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body-search-wrapper")
      }, /*#__PURE__*/React.createElement(Search, {
        prefixCls: "".concat(prefixCls, "-search"),
        onChange: this.handleFilter,
        handleClear: this.handleClear,
        placeholder: searchPlaceholder,
        value: filter
      })) : null;
      var listBody = bodyDom || /*#__PURE__*/React.createElement("div", {
        className: showSearch ? "".concat(prefixCls, "-body ").concat(prefixCls, "-body-with-search") : "".concat(prefixCls, "-body")
      }, search, /*#__PURE__*/React.createElement(Droppable, {
        droppableId: "droppable_".concat(id),
        direction: "vertical",
        isDropDisabled: !draggable
      }, function (provided, snapshot) {
        return /*#__PURE__*/React.createElement("div", {
          ref: provided.innerRef,
          key: id,
          className: "".concat(prefixCls, "-content")
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'none'
          }
        }, provided.placeholder), /*#__PURE__*/React.createElement(Animate, {
          component: "ul",
          transitionName: _this4.state.mounted ? "".concat(prefixCls, "-content-item-highlight") : '',
          transitionLeave: false
        }, showItems), /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-delete-selected ").concat(snapshot.isDraggingOver && droppableId === 'droppable_2' ? 'show' : '')
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-del-btn")
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "uf-arrow-down-2"
        }), /*#__PURE__*/React.createElement("span", null, "\u79FB\u9664\u5DF2\u9009"))));
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body-not-found ").concat(dataSource.length == 0 ? "show" : "")
      }, notFoundContent));
      var listFooter = footerDom ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footerDom) : null;
      var renderedCheckbox = this.renderCheckbox({
        prefixCls: outerPrefixCls,
        checked: checkStatus === 'all',
        checkPart: checkStatus === 'part',
        checkable: /*#__PURE__*/React.createElement("span", {
          className: "".concat(outerPrefixCls, "-checkbox-inner")
        }),
        filteredDataSource: filteredDataSource,
        disabled: false
      });
      return /*#__PURE__*/React.createElement("div", {
        className: listCls,
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, showCheckbox ? renderedCheckbox : '', /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-header-selected")
      }, /*#__PURE__*/React.createElement("span", null, (checkedKeys.length > 0 ? "".concat(checkedKeys.length, "/") : '') + totalDataSource.length, " ", unit), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-header-title")
      }, titleText))), listBody, listFooter);
    }
  }]);

  return TransferList;
}(React.Component);

TransferList.defaultProps = defaultProps;
export default TransferList;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transfer/src/list.js